module.exports = __webpack_public_path__ + "static/fig-576e1ab0f0f038efd791e68dc8a8ebd2.svg";